import NazioniModel from "stores/simulazione/models/NazioniModel";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import { ReduxDispatch } from "../../models/ReduxProps";
import ActionUtility from "../../utilities/ActionUtility";
import LookUpEffect, { IConvenzioniRequest } from "./LookUpEffect";
import AdministrativeCategoryModel from "./models/AdminisrativeCategoryModel";
import AuthorityTypeModel from "./models/AuthorityTypeModel";
import CanaliModel from "./models/CanaliModel";
import ConvenzioniModel from "./models/ConvenzioniModel";
import DocumentTypeModel from "./models/DocumentTypeModel";
import LookupManagementModel from "./models/LookupManagementModel";
import ProdottiModel from "./models/ProdottiModel";
import RequestedTypeModel from "./models/RequestedTypeModel";
import SegmentiModel from "./models/SegmentiModel";
import TipoSimulazioneModel from "./models/TipoRichiestaModel";
import ComuniModel from "../simulazione/models/ComuniModel";
import TipoProdottoModel from "./models/TipoProdottoModel";
import AddressTypeModel from "./models/AddressTypeModel";
import AgentiProvvModel from "./models/AgentiProvvModel";
import SubLevelsModel from "./models/SubLevelsModel";

type ActionUnion =
    | undefined
    | HttpErrorResponseModel
    | TipoSimulazioneModel[]
    | AdministrativeCategoryModel[]
    | RequestedTypeModel[]
    | LookupManagementModel[]
    | CanaliModel[]
    | AgentiProvvModel[]
    | SegmentiModel[]
    | ProdottiModel[]
    | ConvenzioniModel[]
    | DocumentTypeModel[]
    | AuthorityTypeModel[]
    | NazioniModel[]
    | ComuniModel[]
    | TipoProdottoModel[]
    | AddressTypeModel[];

export default class LookUpAction {
    public static readonly REQUEST_LOOKUP_ADMINISTRATIVE_CATEGORY_GET: string =
        "LookUpAction.REQUEST_LOOKUP_ADMINISTRATIVE_CATEGORY_GET";
    public static readonly REQUEST_LOOKUP_ADMINISTRATIVE_CATEGORY_GET_FINISHED: string =
        "LookUpAction.REQUEST_LOOKUP_ADMINISTRATIVE_CATEGORY_GET_FINISHED";

    public static readonly REQUEST_LOOKUP_REQUESTED_TYPE_GET: string = "LookUpAction.REQUEST_LOOKUP_REQUESTED_TYPE_GET";
    public static readonly REQUEST_LOOKUP_REQUESTED_TYPE_GET_FINISHED: string =
        "LookUpAction.REQUEST_LOOKUP_REQUESTED_TYPE_GET_FINISHED";

    public static readonly REQUEST_LOOKUP_MANAGEMENT_GET: string = "LookUpAction.REQUEST_LOOKUP_MANAGEMENT_GET";
    public static readonly REQUEST_LOOKUP_MANAGEMENT_GET_FINISHED: string =
        "LookUpAction.REQUEST_LOOKUP_MANAGEMENT_GET_FINISHED";

    public static readonly REQUEST_LOOKUP_CANALI_GET: string = "LookUpAction.REQUEST_LOOKUP_CANALI_GET";
    public static readonly REQUEST_LOOKUP_CANALI_GET_FINISHED: string =
        "LookUpAction.REQUEST_LOOKUP_CANALI_GET_FINISHED";
    public static readonly REQUEST_LOOKUP_CANALI_GET_RESET: string = "LookUpAction.REQUEST_LOOKUP_CANALI_RESET";
    public static readonly REQUEST_LOOKUP_SEGMENTI_GET: string = "LookUpAction.REQUEST_LOOKUP_SEGMENTI_GET";
    public static readonly REQUEST_LOOKUP_SEGMENTI_GET_FINISHED: string =
        "LookUpAction.REQUEST_LOOKUP_SEGMENTI_GET_FINISHED";

    public static readonly REQUEST_LOOKUP_AGENTIPROVV_GET: string = "LookUpAction.REQUEST_LOOKUP_AGENTIPROVV_GET";
    public static readonly REQUEST_LOOKUP_AGENTIPROVV_GET_FINISHED: string =
        "LookUpAction.REQUEST_LOOKUP_AGENTIPROVV_GET_FINISHED";

    public static readonly REQUEST_LOOKUP_PRODOTTI_GET: string = "LookUpAction.REQUEST_LOOKUP_PRODOTTI_GET";
    public static readonly REQUEST_LOOKUP_PRODOTTI_GET_FINISHED: string =
        "LookUpAction.REQUEST_LOOKUP_PRODOTTI_GET_FINISHED";

    public static readonly REQUEST_LOOKUP_CONVENZIONI_GET: string = "LookUpAction.REQUEST_LOOKUP_CONVENZIONI_GET";
    public static readonly REQUEST_LOOKUP_CONVENZIONI_GET_FINISHED: string =
        "LookUpAction.REQUEST_LOOKUP_CONVENZIONI_GET_FINISHED";

    public static readonly REQUEST_LOOKUP_DOCUMENT_TYPES_GET: string = "LookUpAction.REQUEST_LOOKUP_DOCUMENT_TYPES_GET";
    public static readonly REQUEST_LOOKUP_DOCUMENT_TYPES_GET_FINISHED: string =
        "LookUpAction.REQUEST_LOOKUP_DOCUMENT_TYPES_GET_FINISHED";

    public static readonly REQUEST_LOOKUP_AUTHORITY_TYPES_GET: string =
        "LookUpAction.REQUEST_LOOKUP_AUTHORITY_TYPES_GET";
    public static readonly REQUEST_LOOKUP_AUTHORITY_TYPES_GET_FINISHED: string =
        "LookUpAction.REQUEST_LOOKUP_AUTHORITY_TYPES_GET_FINISHED";

    public static readonly REQUEST_LOOKUP_NAZIONI_GET: string = "LookUpAction.REQUEST_LOOKUP_NAZIONI_GET";
    public static readonly REQUEST_LOOKUP_NAZIONI_GET_FINISHED: string =
        "LookUpAction.REQUEST_LOOKUP_NAZIONI_GET_FINISHED";

    public static readonly REQUEST_LOOKUP_COMUNI_GET_BIRTH_PLACE: string =
        "LookUpAction.REQUEST_LOOKUP_COMUNI_GET_BIRTH_PLACE";
    public static readonly REQUEST_LOOKUP_COMUNI_GET_BIRTH_PLACE_FINISHED: string =
        "LookUpAction.REQUEST_LOOKUP_COMUNI_GET_BIRTH_PLACE_FINISHED";

    public static readonly REQUEST_LOOKUP_COMUNI_GET_RESIDENCE_PLACE: string =
        "LookUpAction.REQUEST_LOOKUP_COMUNI_GET_RESIDENCE_PLACE";
    public static readonly REQUEST_LOOKUP_COMUNI_GET_RESIDENCE_PLACE_FINISHED: string =
        "LookUpAction.REQUEST_LOOKUP_COMUNI_GET_RESIDENCE_PLACE_FINISHED";

    public static readonly REQUEST_LOOKUP_PRODUCT_TYPES_GET: string = "LookUpAction.REQUEST_LOOKUP_PRODUCT_TYPES_GET";
    public static readonly REQUEST_LOOKUP_PRODUCT_TYPES_GET_FINISHED: string =
        "LookUpAction.REQUEST_LOOKUP_PRODUCT_TYPES_GET_FINISHED";

    public static readonly REQUEST_LOOKUP_ADDRESS_TYPES_GET: string = "LookUpAction.REQUEST_LOOKUP_ADDRESS_TYPES_GET";
    public static readonly REQUEST_LOOKUP_ADDRESS_TYPES_GET_FINISHED: string =
        "LookUpAction.REQUEST_LOOKUP_ADDRESS_TYPES_GET_FINISHED";

    public static readonly REQUEST_LOOKUP_SUB_LEVELS_GET: string = "LookUpAction.REQUEST_LOOKUP_SUB_LEVELS_GET";
    public static readonly REQUEST_LOOKUP_SUB_LEVELS_GET_FINISHED: string =
        "LookUpAction.REQUEST_LOOKUP_SUB_LEVELS_GET_FINISHED";

    public static administrativeCategoryGet(idRequestedType?: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<AdministrativeCategoryModel[]>(
                dispatch,
                LookUpAction.REQUEST_LOOKUP_ADMINISTRATIVE_CATEGORY_GET,
                LookUpEffect.lookupAdministrativeCategoryGet,
                idRequestedType
            );
        };
    }

    public static requestedTypeGet(id: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<RequestedTypeModel[]>(
                dispatch,
                LookUpAction.REQUEST_LOOKUP_REQUESTED_TYPE_GET,
                LookUpEffect.lookupRequestedTypeGet,
                id
            );
        };
    }

    public static lookupManagementGet(text: string, idAdmCategory?: string, includeExceptions?: boolean): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<LookupManagementModel[]>(
                dispatch,
                LookUpAction.REQUEST_LOOKUP_MANAGEMENT_GET,
                LookUpEffect.lookupManagementGet,
                text,
                idAdmCategory,
                includeExceptions
            );
        };
    }

    public static canaliGet(idAgent?: number, isAdmin?: boolean): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<CanaliModel[]>(
                dispatch,
                LookUpAction.REQUEST_LOOKUP_CANALI_GET,
                LookUpEffect.canaliGet,
                idAgent,
                isAdmin
            );
        };
    }

    public static resetCanali(): any {
        return ActionUtility.createAction(LookUpAction.REQUEST_LOOKUP_CANALI_GET_RESET);
    }

    public static agentiProvvGet(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<AgentiProvvModel[]>(
                dispatch,
                LookUpAction.REQUEST_LOOKUP_AGENTIPROVV_GET,
                LookUpEffect.agentiGet
            );
        };
    }

    public static segmentiGet(
        idRequestedType: number,
        idAdministrativeCategory: number,
        idChannel: number,
        idAgent?: number
    ): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<SegmentiModel[]>(
                dispatch,
                LookUpAction.REQUEST_LOOKUP_SEGMENTI_GET,
                LookUpEffect.segmentiGet,
                idRequestedType,
                idAdministrativeCategory,
                idChannel,
                idAgent
            );
        };
    }

    public static prodottiGet(
        idRequestedType: number,
        idAdministrativeCategory: number,
        segment: string,
        idAgent?: number
    ): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ProdottiModel[]>(
                dispatch,
                LookUpAction.REQUEST_LOOKUP_PRODOTTI_GET,
                LookUpEffect.prodottiGet,
                idRequestedType,
                idAdministrativeCategory,
                segment,
                idAgent
            );
        };
    }

    public static convenzioniGet(request: IConvenzioniRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ConvenzioniModel[]>(
                dispatch,
                LookUpAction.REQUEST_LOOKUP_CONVENZIONI_GET,
                LookUpEffect.convenzioniGet,
                request
            );
        };
    }

    public static documentTypesGet(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<DocumentTypeModel[]>(
                dispatch,
                LookUpAction.REQUEST_LOOKUP_DOCUMENT_TYPES_GET,
                LookUpEffect.lookupDocumentTypesGet
            );
        };
    }

    public static authoprityTypesGet(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<AuthorityTypeModel[]>(
                dispatch,
                LookUpAction.REQUEST_LOOKUP_AUTHORITY_TYPES_GET,
                LookUpEffect.lookupAuthorityTypesGet
            );
        };
    }

    public static nazioniGet(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<NazioniModel[]>(
                dispatch,
                LookUpAction.REQUEST_LOOKUP_NAZIONI_GET,
                LookUpEffect.nazioniGet
            );
        };
    }

    public static comuniGetBirthPlace(nazione: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ComuniModel[]>(
                dispatch,
                LookUpAction.REQUEST_LOOKUP_COMUNI_GET_BIRTH_PLACE,
                LookUpEffect.comuniGet,
                nazione
            );
        };
    }

    public static comuniGetResidencePlace(nazione: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ComuniModel[]>(
                dispatch,
                LookUpAction.REQUEST_LOOKUP_COMUNI_GET_RESIDENCE_PLACE,
                LookUpEffect.comuniGet,
                nazione
            );
        };
    }

    public static productTypesGet(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<TipoProdottoModel[]>(
                dispatch,
                LookUpAction.REQUEST_LOOKUP_PRODUCT_TYPES_GET,
                LookUpEffect.lookupProductTypesGet
            );
        };
    }

    public static addressTypesGet(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<AddressTypeModel[]>(
                dispatch,
                LookUpAction.REQUEST_LOOKUP_ADDRESS_TYPES_GET,
                LookUpEffect.lookupAddressTypesGet
            );
        };
    }

    public static subLevelsGet(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<SubLevelsModel[]>(
                dispatch,
                LookUpAction.REQUEST_LOOKUP_SUB_LEVELS_GET,
                LookUpEffect.lookupSubLevelsGet
            );
        };
    }
}
